import { render } from "./AndroidCardDe.vue?vue&type=template&id=2b122ceb&scoped=true"
import script from "./AndroidCardDe.vue?vue&type=script&lang=js"
export * from "./AndroidCardDe.vue?vue&type=script&lang=js"

import "./AndroidCardDe.vue?vue&type=style&index=0&id=2b122ceb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b122ceb"]])

export default __exports__